module.exports = __webpack_public_path__ + "media/images/download/e-book03-3b24af79460281db0874efe25d4a6845.png";